import { FC, PropsWithChildren } from 'react';
import { CatUtilityNav } from '@blocks-react/components/UtilityNav';

export const SubheaderUtilityNav: FC<PropsWithChildren> = ({ children }) => {
  return <CatUtilityNav data-testId="subheader-utility-nav">{children}</CatUtilityNav>;
};
